import {
  isNode,
  findInCallbacksByUrlFormat,
  findInCallbacksByName,
} from '../helpers';
import { getObjectByPath } from '../../applyMenuConfigChanges/utils';
import { pathToTreeKeys } from '../../applyMenuConfigChanges/deleteMembers';
import { PARAM_TYPES } from './types';
import { Parameter, Service } from '../../../types';
import { isLegacyType } from '../../../client/components/TypeDetails/typeParser';
import { getTypeSuffix } from '../../typeUtils';

const shouldMarkCallbackParams = (tree, param: Parameter): boolean => {
  const shouldAddTypeMetadataToParam = (
    paramNode: { data: Service },
    paramKey: string,
  ): boolean =>
    paramNode?.data &&
    (findInCallbacksByUrlFormat(paramNode, paramKey) ||
      findInCallbacksByName(paramNode, paramKey));

  const parameterTypePath =
    typeof param.type === 'string' ? param.type : param.type[0].referenceType;
  const paramNode = getObjectByPath(tree, pathToTreeKeys(parameterTypePath));
  const paramKey = getTypeSuffix(parameterTypePath);
  return shouldAddTypeMetadataToParam(paramNode, paramKey);
};

const markCallbackParams = (tree) => (operation) => {
  operation.params
    .filter((param) => {
      /*
      Operation parameters which are not referencing to a message can't be callbacks.
      Callback parameters has to point to the callback message.
       */
      if (isLegacyType(param.type)) {
        return typeof param.type === 'string';
      }
      return param.type[0].referenceType;
    })
    .forEach((param) => {
      if (shouldMarkCallbackParams(tree, param)) {
        param.metaData = {};
        param.metaData.type = PARAM_TYPES.FUNCTION;
      }
    });
};

export const markCallbacksVisitor = (tree) => {
  return (node) => {
    if (node?.data) {
      if (node.data.operations) {
        node.data.operations.forEach(markCallbackParams(tree));
      }
      if (node.data.clientEvents) {
        node.data.clientEvents.forEach(markCallbackParams(tree));
      }
    }
  };
};
